import client from "api/client";

import { setToken, setUser, clearSession } from "auth/storage";

// Authenticate against the API and persist the session.
// Returns the raw login payload: { token, user, message? }.
export const login = async (email, password) => {
  const { data } = await client.post("/auth/login", { email, password });
  if (!data?.token) {
    throw new Error(data?.message || "Login failed.");
  }
  setToken(data.token);
  setUser(data.user);
  return data;
};

export const logout = () => clearSession();
